import { string, bool } from 'prop-types';
import React from 'react';
import { CheckBox as Check, Wrapper } from './styles';

function CheckBox({ id, description, value, ...rest }) {
  return (
    <Wrapper key={id}>
      <Check id={id} checked={Boolean(value)} {...rest} />
      <label htmlFor={id}>{description}</label>
    </Wrapper>
  );
}

CheckBox.propTypes = {
  description: string,
  id: string.isRequired,
  value: bool,
};

CheckBox.defaultProps = {
  description: '',
  value: false,
};

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/CheckBoxes/CheckBox.js